import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { PAGE_SIZE_OPTIONS, usePaginationLocation } from 'components/molecules/PaginationBar/pagination-location-hook'
import { changeOrdersPage, changeOrdersPageSize, fetchOrdersRequest } from 'store/orders/orders.actions'
import { selectFinishedOrdersDateFrom, selectFinishedOrdersDateTo, selectOrdersPageSize } from 'store/orders/orders.selectors'

export const useOrderListPagination = () => {
  const dispatch = useDispatch()
  const pageSize = useSelector(selectOrdersPageSize)
  const dateFrom = useSelector(selectFinishedOrdersDateFrom)
  const dateTo = useSelector(selectFinishedOrdersDateTo)
  const paginationLocation = usePaginationLocation()

  const getPeriodPayload = useCallback(() => {
    if (!dateFrom || !dateTo) return undefined

    return { period: { dateFrom, dateTo } }
  }, [dateFrom, dateTo])

  const changePage = useCallback(
    (page: number) => {
      paginationLocation.setPage(page)
      dispatch(changeOrdersPage(page))
      dispatch(fetchOrdersRequest(getPeriodPayload()))
      window.scrollTo(0, 0)
    },
    [dispatch, getPeriodPayload, paginationLocation],
  )

  const changePageSize = useCallback(
    (nextPageSize: number) => {
      if (!PAGE_SIZE_OPTIONS.includes(nextPageSize as typeof PAGE_SIZE_OPTIONS[number])) return

      paginationLocation.setPageSize(nextPageSize)
      dispatch(changeOrdersPageSize(nextPageSize))
      dispatch(fetchOrdersRequest(getPeriodPayload()))
      window.scrollTo(0, 0)
    },
    [dispatch, getPeriodPayload, paginationLocation],
  )

  return { changePage, changePageSize, pageSize, pageSizeOptions: PAGE_SIZE_OPTIONS }
}
